<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <graph-panel v-if="statusGraph"
        :graphTitle="$i18n.t('graph.statistics_by_status')"
        :periodes="['lastDay', 'lastWeek', 'lastMonth', 'lastYear']"
        @fetch-periode="fetchGraphStatus($event)"
        @filter-graph="filterStatus($event)"
        @clear-filter="clearFilterStatus()"
        :ibans="ibans"
        :contacts="contacts"
        :documentTypes="docTypes"
        :trueValueLabel="$i18n.t('graph.shw_amnt')"
        :falseValueLabel="$i18n.t('graph.shw_nmbr')"
        v-model="showingStatus">
        <graph-by-date-status
          :showAmountNotNumber="showingStatus"
          :chartData="statusGraph"
          :dates="dates">
        </graph-by-date-status>
      </graph-panel>
    </template>
  </page-outline>
</template>

<script>

import PageOutline from '@/components/common/PageOutline.vue'

import graphByDateStatus from '@/pages/statistics/components/GraphByDateStatus.vue'
import graphByStatus from '@/pages/statistics/components/GraphByStatus.vue'
import graphByDocumentStatus from '@/pages/statistics/components/GraphByDocumentStatus.vue'
import graphByBalance from '@/pages/statistics/components/GraphByBalance.vue'
import graphByContact from '@/pages/statistics/components/GraphByContact.vue'
import graphPanel from '@/pages/statistics/components/GraphPanel.vue'
import documentSerialize from '@/helpers/documentSerialize.json'
import MPstats from '@/pages/statistics/components/MarketPlace/MPstats.vue'
import CashStats from '@/pages/statistics/components/CashFlow/CashStats.vue'

import {errorMessageAlert} from '@/helpers/alert'

export default {
  components: {
    'graph-by-date-status': graphByDateStatus,
    'graph-by-status': graphByStatus,
    'graph-by-document-status': graphByDocumentStatus,
    'graph-by-balance': graphByBalance,
    'graph-by-contact': graphByContact,
    'graph-panel': graphPanel,
    'page-outline': PageOutline,
    MPstats,
    CashStats
  },
  data () {
    return {
      dates: {},
      demo: true,
      amount: true,
      pStatus: 'month',
      ibanStatus: [],
      contactStatus: [],
      ibans: [],
      contacts: [],
      docTypes: [],
      showingStatus: true,
      showingBalance: true,
      showingContact: true,
      statusGraph: undefined,
      serviceId: 1
    }
  },
  computed: {
    canSeeSRTP () {
      return this.$engine.rights.rightIs('rtp_norm_srtp', true)
    },
    canSeeHRTP () {
      return this.$engine.rights.rightIs('rtp_norm_hrtp', true)
    },
    pageTitle () {
      return this.$i18n.t('graph.statistics_by_status')
    }
  },
  created () {
    // this.$engine.monitoring.initAllGraphs('month')
    this.ibans = this.$engine.bankAccounts.get().map(entry => ({name: entry.name, iban: entry.iban}))
    this.contacts = this.$engine.contacts.get().map(entry => ({id: entry.identifier, alias: entry.label}))
    let keys = Object.keys(documentSerialize)
    for (var i = 0; i < keys.length; i++) {
      if (!documentSerialize[keys[i]].disabled) {
        this.docTypes.push({'id': keys[i], 'label': this.$t(documentSerialize[keys[i]].label)})
      }
    }

    this.dates = this.$engine.monitoring.getDatesFromPeriode('month')


  let standard = undefined
    if (this.canSeeSRTP && !this.canSeeHRTP) {
      standard = '1'
    } else if (!this.canSeeSRTP && this.canSeeHRTP) {
      standard = '2'
    } else if (!this.canSeeSRTP && !this.canSeeHRTP) {
      standard = '0'
    }
    this.$engine.monitoring.fetchPromise({
      'service': 1,
      'dateBegin': this.dates.begin,
      'dateEnd': this.dates.end,
      'getDate': 1,
      'getIban': 0,
      'getContact': 0,
      'standard': standard
    }).then(resp => {
      this.$engine.monitoring.rawByStatus = resp.data
      // console.log(this.docStatusToGraphStatus(resp.data))
      // const filteredData = this.$engine.monitoring.applyFilterOnData(this.docStatusToGraphStatus(resp.data), this.$engine.monitoring.filterGraphStatus)
      this.$engine.monitoring.graphByStatus = this.$engine.monitoring.makeGraphByStatus(resp.data, '1')
      this.statusGraph = this.$engine.monitoring.graphByStatus
      console.log('statusGraph', this.statusGraph)
    })
    .catch(err => {
      errorMessageAlert(error, this)
    })
    // this.statusGraph = {
    //   'creditor': {
    //     '2023-09-01': {
    //       '5': {
    //         'number': 75
    //       },
    //       '12': {
    //         'number': 25
    //       },
    //       '13': {
    //         'number': 27
    //       }
    //     }
    //   },
    //   'debtor': {
    //     '2023-09-01': {
    //       '5': {
    //         'number': 75
    //       },
    //       '12': {
    //         'number': 25
    //       },
    //       '13': {
    //         'number': 27
    //       }
    //     }
    //   }
    // }
  },
  methods: {
    // Fetch Methods
    fetchGraphStatus (periode) {
      this.$engine.monitoring.fetchGraphByStatus(periode).then(resp => {
        this.statusGraph = resp
      })
    },
    fetchGraphBalance (periode) {
      this.$engine.monitoring.fetchGraphByBalance(periode)
    },
    fetchGraphContact (periode) {
      this.$engine.monitoring.fetchGraphByContact(periode)
    },

    // Transform Methods
    docStatusToGraphStatus (docStatus) {
      docStatus['creditor'] = {}
      docStatus['0'].forEach((item, i) => {
        docStatus['creditor']['Doc_' + item.status] = {'amount': item.number}
      })
      delete docStatus['0']

      docStatus['debtor'] = {}
      docStatus['1'].forEach((item, i) => {
        docStatus['debtor']['Doc_' + item.status] = {'amount': item.number}
      })
      delete docStatus['1']
      return docStatus
    },

    // Filter Methods
    filterStatus ({period = 'lastMonth', ibans, contacts, docTypes}) {
      this.statusGraph = undefined
      let filter = []
      docTypes.forEach((item, i) => {
        filter.push({'type': item})
      })
      if (filter.length === 0) {
        filter = undefined
      }
      this.dates = this.$engine.monitoring.getDatesFromPeriode(period)
      let that = this
      this.$engine.monitoring.fetchPromise({
        'service': this.serviceId,
        'dateBegin': this.dates.begin,
        'dateEnd': this.dates.end,
        'getDate': 1,
        'getIban': 0,
        'getContact': 0,
        'types': filter
      })
      .then(resp => {
        if (resp.status === 200) {
          // that.$engine.monitoring.graphByStatus = that.docStatusToGraphStatus(resp.data)
          that.$engine.monitoring.graphByStatus = this.$engine.monitoring.makeGraphByStatus(resp.data, that.serviceId)
          that.statusGraph = that.$engine.monitoring.graphByStatus
        }
      })
      // this.statusGraph = this.$engine.monitoring.filterForGraphStatus(this.docTypes, this.docTypes)
    },
    filterBalance ({ibans, contacts}) {
      this.$engine.monitoring.filterForGraphBalance(ibans, contacts)
    },
    filterContact ({ibans, contacts}) {
      this.statusGraph = this.$engine.monitoring.filterForGraphContact(ibans, contacts)
    },
    // Clear Methods
    clearFilterStatus () {
      this.ibanStatus = []
      this.contactStatus = []
      this.statusGraph = this.$engine.monitoring.clearFilterForGraphStatus()
    },
    clearFilterBalance () {
      this.$engine.monitoring.clearFilterForGraphBalance()
    },
    clearFilterContact () {
      this.$engine.monitoring.clearFilterForGraphContact()
    }
  }
}
</script>

<style lang="css" scoped>
.borderRounded {
  border-radius:10px;
}
.separator {
  border-bottom: 1px solid silver;
  margin-top: 40px;
  margin-bottom: 40px;
}

.spacer {
  margin-top: 40px;
  margin-bottom: 40px;
}
</style>
